export default __webpack_public_path__ + "static/media/ReleaseNotes_LoadRequest_OrderPage.7ef6bab6.png";